module.exports = __webpack_public_path__ + "static/img/1-2.412b3e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/1-2.png
// module id = HfVB
// module chunks = 0